<script lang="ts">
  import Meta from "$lib/components/meta/MetaUserGallery.svelte";
  import { page } from "$app/stores";

  const format_descrition = () => {
    let d: string = $page.data.meta?.description ?? "";
    if (d.length > 90) {
      return `${d.substring(0, 90)}...`;
    }
    return d;
  };
  export let data;
</script>

{#key $page.url}
  <Meta
    title={data.meta.title}
    description={format_descrition()}
    id={data.uuid}
  />
{/key}
